import en from '@/lib/locales/en-combined';
import i18n from 'i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';

export function createI18n() {
  // set currentLanguage here to change language
  const currentLanguage = 'en';
  const resources = { en };

  return i18n.use(intervalPlural).init({
    lng: currentLanguage,
    ns: ['common'],
    defaultNS: 'common',
    resources,
    fallbackLng: {
      default: ['en'],
    },
    interpolation: {
      escapeValue: false,
      defaultVariables: {},
      format: function (value, format) {
        if (format === 'capitalize') {
          const strLower = value?.toLowerCase();
          return strLower?.charAt(0)?.toUpperCase() + strLower?.slice(1);
        }

        return value;
      },
    },
  });
}
